function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMicrophone02(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "microphone-02"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M11.4446 7V7.55556C11.4446 10.0102 9.45471 12 7.00011 12C4.54551 12 2.55566 10.0102 2.55566 7.55556V7M7.00011 9.77778C5.77281 9.77778 4.77789 8.78285 4.77789 7.55556V4.22222C4.77789 2.99492 5.77281 2 7.00011 2C8.22741 2 9.22233 2.99492 9.22233 4.22222V7.55556C9.22233 8.78285 8.22741 9.77778 7.00011 9.77778Z",
    stroke: "white",
    style: {
      stroke: "white",
      strokeOpacity: 1
    },
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMicrophone02);
export default __webpack_public_path__ + "static/media/microphone-02.072f7142e4c694185dfc050ccab6d9d4.svg";
export { ForwardRef as ReactComponent };